import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const categoryListApi = async (data) => {
    const endPoint =
        `categories/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
// add category
export const addCategoryApi = async (data) => {
    const endPoint = `categories/add`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit category------------------
export const updateCategoryApi = async (data) => {
    const endPoint = `categories/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
// -----------------------change status and delete category----------------------------
export const updateStatus = async (data) => {
    const endPoint = `categories/status`;
    return await axios.put(endPoint, data, setJwtToken());
};
// category remove
export const removeCategory = async (id) => {
    const endPoint = `categories/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};




// subCategory

export const SubCategoryListApi = async (data) => {
    const endPoint =
        `subcategories/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
// add SubCategory
export const addSubCategoryApi = async (data) => {
    const endPoint = `subcategories/add`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit SubCategory------------------
export const updateSubCategoryApi = async (data) => {
    const endPoint = `subcategories/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
// -----------------------change status and delete SubCategory----------------------------
export const updateSubCategoryStatus = async (data) => {
    const endPoint = `subcategories/status`;
    return await axios.put(endPoint, data, setJwtToken());
};
// SubCategory remove
export const removeSubCategory = async (id) => {
    const endPoint = `subcategories/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
}
